<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="wrapper">
      <div class="header"><span>{{hint.title || '温馨提示'}}</span><i class="icon icon-close" @click.stop="maskClicked()"></i></div>
      <div class="main-box">
        <div class="item" v-for="item in hint.list">
          <div>{{item.title}}</div>
          <p>{{item.content}}</p>
        </div>
      </div>

    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  name: 'remindHint',
  data () {
    return {}
  },
  props: {
    //    disclaimer: {
    //      type: String,
    //      default: ''
    //    },
    hint: {
      type: Object,
      default: {
        list: []
      }
    },
    showModal: {
      type: Boolean,
      default: false
    }
    //    recordCode: {
    //      type: Boolean,
    //      default: false
    //    },
    //    showTxt: {
    //      type: String,
    //      default: ''
    //    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },

  methods: {

    maskClicked (e) {
      this.$emit('close')
    }
  }
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .van-popup {
    border-radius: 10px;
    padding-bottom: 50px;
  }

  .wrapper {
    width: 320px;
    /*max*/
    padding: 20px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    position: relative;
    span {
      font-weight: bold;
      font-size: 18px;
      &:before {
        content: ' ';
        display: block;
        position: absolute;
        bottom: 24px;
        width: 30px;
        border-bottom: 2px solid $assertive;
      }
    }
    .icon {
      font-size: 26px;
    }
  }

  .main-box {
    max-height: 400px;
    overflow-y: auto;
  }

  .item {
    padding-bottom: 18px;
    div {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 6px;
    }

    p {
      font-size: 14px;
    }
  }
</style>
